import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { validateEmailFunc, isRutValid, validateCell, beforeMaskedValueChangeRut, decode_utf8, maxFileSize, getSignedIdStatus, extensionsAccepted, transformId } from '../../../../common/utils/utilsFunc';
import WebContentTermsElectrod from '../WebContentTermsElectrod';
import { useModal } from "@clayui/modal";
import FileUploaded from "../../../../common/components/FileUploader";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function BajaSolicitud({ props }) {
    const [nombreTutor, setNombreTutor] = React.useState('');
    const [ruTutor, setRutTutor] = React.useState('');
    const [telefonoTutor, setTelefonoTutor] = React.useState('');
    const [correoTutor, setCorreoTutor] = React.useState('');
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [valueCheckBoxTerms, setValueCheckBoxTerms] = React.useState(false);
    const [erroUploadFile, setErroUploadFile] = React.useState();
    const [values, setValues] = React.useState({})
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });

    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);
    const motivoOptions = [
        { value: "NoElectrodependiente", label: "Ya no es electrodependiente" },
        { value: "PorDefuncion", label: "Por Defunción" },
    ];

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    React.useEffect(() => {
        if (props.resetForm) {
            setValues({
                regionPatient: 0,
                comunaPatient: 0,
                calleNDptoPatient: "",
                cellphonePatient: "",
                cellphoneTutor: "",
                diagnosticPatient: "",
                edadPatient: "",
                emailPatient: "",
                emailTutor: "",
                fechaDesde: "",
                fechaHora: "",
                fileCertificate: null,
                declaracionSimple: null,
                namePatient: "",
                nameTutor: "",
                rutPatient: "",
                rutTutor: ""
            })
            clearInputFile("fileCertificate")
            clearInputFile("declaracionSimple")
            setValueCheckBoxTerms(false)
            props.setDetailClientJson([])
            props.setResetForm(false)
        }
    }, [props.resetForm])

    React.useEffect(() => {
        if (erroUploadFile) {
            props.setGlobalAlert(erroUploadFile, "warning");
        }
    }, [erroUploadFile]);

    function clearInputFile(id) {
        let inputFile = document.querySelector(`#${id}`);
        inputFile.value = ''
    }
    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (valueCheckBoxTerms) {
            errors.empty.valueCheckBoxTerms = false;
        } else {
            errors.empty.valueCheckBoxTerms = true;
            errors.msg.valueCheckBoxTerms = "Debes aceptar los términos y condiciones."
        }

        if (nombreTutor) {
            errors.empty.nameTutor = false;
        } else {
            errors.empty.nameTutor = true;
            errors.msg.nameTutor = "Debes ingresar el nombre del representante legal o apoderado del paciente"
        }

        if (values.fileCertificate) {
            errors.empty.fileCertificate = false;
        } else {
            errors.empty.fileCertificate = true;
            errors.msg.fileCertificate = "Debes adjuntar certificado médico que acredita condición de electrodependencia"
        }

        if (values.declaracionSimple) {
            errors.empty.declaracionSimple = false;
        } else {
            errors.empty.declaracionSimple = true;
            errors.msg.declaracionSimple = "Debes adjuntar Declaración simple"
        }

        if (correoTutor) {
            errors.empty.emailTutor = false;
            if (correoTutor && !validateEmailFunc(correoTutor)) {
                errors.validated.emailTutor = true;
                errors.msg.emailTutor = "Debes ingresar el correo electrónico del representante legal o apoderado del paciente válido"
            } else {
                errors.validated.emailTutor = false;
            }
        } else {
            errors.empty.emailTutor = true;
            errors.msg.emailTutor = "Debes ingresar el correo electrónico del representante legal o apoderado del pacientee"
        }

        if (ruTutor) {
            errors.empty.rutTutor = false;
            if (!isRutValid(ruTutor)) {
                errors.validated.rutTutor = true;
                errors.msg.rutTutor = "Debes ingresar un RUT del representante legal o apoderado del paciente válido."
            } else {
                errors.validated.rutTutor = false;
            }
        } else {
            errors.empty.rutTutor = true;
            errors.msg.rutTutor = "Debes ingresar el RUT del representante legal o apoderado del paciente."
        }

        if (telefonoTutor) {
            errors.empty.cellphoneTutor = false;
            if (validateCell(telefonoTutor)) {
                errors.validated.cellphoneTutor = true;
                errors.msg.cellphoneTutor = "Debes ingresar un correo electrónico del representante legal o apoderado del paciente que sea válido"
            } else {
                errors.validated.cellphoneTutor = false;
            }
        } else {
            errors.empty.cellphoneTutor = true;
            errors.msg.cellphoneTutor = "Debes ingresar el teléfono del representante legal o apoderado del paciente"
        }

        setInputValidate(errors)
        return errors
    }

    function handleSubmit() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        }  else {
            let json = [
                {
                    "idSolicitudED": props.detailSolcitudJson.id,
                    "nroCliente": props.detailClientJson.CTA_CTO,
                    "nombrePaciente": props.detailSolcitudJson.nombrePaciente,
                    "rutPaciente": props.detailSolcitudJson.rutPaciente,
                    "fonoPaciente": props.detailSolcitudJson.fonoPaciente,
                    "emailPaciente": props.detailSolcitudJson.emailPaciente,
                    "edadPaciente": props.detailSolcitudJson.edadPaciente,
                    "diagnosticoPaciente": props.detailSolcitudJson.diagnosticoPaciente,
                    "descuento": props.detailSolcitudJson.descuentoPaciente,
                    "calleNDptoPatient": props.detailSolcitudJson.direccionPaciente,
                    "regionPatient": props.detailSolcitudJson.regionPaciente,
                    "comunaPatient": props.detailSolcitudJson.comunaPaciente,
                    "nombreTutor": nombreTutor,
                    "rutTutor": ruTutor,
                    "fonoTutor": telefonoTutor,
                    "emailTutor": correoTutor,
                    "emailInterrupcion": props.detailSolcitudJson.emailContacto,
                    "fechaDesde": props.detailSolcitudJson?.fechaDesde? props.detailSolcitudJson.fechaDesde.split("T")[0] : "",
                    "fechaHasta": props.detailSolcitudJson?.fechaHasta? props.detailSolcitudJson.fechaHasta.split("T")[0] : "",
                    "motivoBaja": values.motivo,
                    "signedIn": getSignedIdStatus(),
                    // eslint-disable-next-line no-undef
                    "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
                    "contentName": decode_utf8(props.web_content_return_fetch_electrodependent),
                    "empresa": props.codigo_empresa,
                    "url": props.url_ws_empresa
                },
                {
                    "certificado": values.fileCertificate,
                    "declaracionSimple": values.declaracionSimple
                }
            ]
            props.setJsonFormBa(json)
        }

    }

    React.useEffect(() => {
        if (props.detailSolcitudJson) {
            setNombreTutor(props.detailSolcitudJson?.nombreTutor || "")
            setRutTutor(props.detailSolcitudJson?.rutTutor || "")
            setTelefonoTutor(props.detailSolcitudJson?.fonoTutor || "")
            setCorreoTutor(props.detailSolcitudJson?.emailTutor || "")
        }
    }, [props.detailSolcitudJson]);
    return (
        <div id="cge-formselectrodependent">
            <CGE.Panel>
                <div className="row">
                    <div className="col-md-12">
                        <CGE.Heading
                            className="color-blue font-weight-bold"
                            size="4"
                            text={"Cancelar solicitud n°: " + props.detailSolcitudJson?.nroSolicitud}

                        />
                    </div>
                </div>
                <CGE.PanelSection
                    title={"Se certifica como electrodependiente al paciente individualizado como:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, namePatient: props.detailSolcitudJson?.nombrePaciente })}
                                idFormElement="namePatient"
                                typeElement="input"
                                labelName="Nombre:"
                                placeholder="Nombre Completo"
                                maxLength="100"
                                hasError={inputValidate?.empty?.namePatient}
                                msgError={inputValidate?.msg?.namePatient}
                                value={props.detailSolcitudJson?.nombrePaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, rutPatient: props.detailSolcitudJson?.rutPaciente })}
                                idFormElement="rutPatient"
                                labelName="Rut:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutPatient || inputValidate?.validated?.rutPatient}
                                msgError={inputValidate?.msg?.rutPatient}
                                value={props.detailSolcitudJson?.rutPaciente || ""}
                                readOnly={true}
                                typeElement="input-mask"
                                maxLength="12"
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, cellphonePatient: props.detailSolcitudJson?.fonoPaciente })}
                                idFormElement="cellphonePatient"
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphonePatient || inputValidate?.validated?.cellphonePatient}
                                msgError={inputValidate?.msg?.cellphonePatient}
                                value={props.detailSolcitudJson?.fonoPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, emailPatient: props.detailSolcitudJson?.emailPaciente })}
                                idFormElement="emailPatient"
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailPatient || inputValidate?.validated?.emailPatient}
                                msgError={inputValidate?.msg?.emailPatient}
                                value={props.detailSolcitudJson?.emailPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, edadPatient: props.detailSolcitudJson.edadPaciente })}
                                idFormElement="edadPatient"
                                labelName="Edad:"
                                placeholder="Edad"
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                value={props.detailSolcitudJson.edadPaciente || ""}
                                readOnly={true}
                                typeFormElement="text"
                                typeElement="input-mask"
                                maxLength="2"
                                formatChars={{
                                    9: "[0-9]"
                                }}
                                mask="99"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, diagnosticPatient: props.detailSolcitudJson.diagnosticoPaciente })}
                                idFormElement="diagnosticPatient"
                                typeElement="input"
                                maxLength="100"
                                labelName="Diagnóstico médico/Patología de Base:"
                                placeholder="Diagnóstico médico"
                                value={props.detailSolcitudJson.diagnosticoPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, descuento: props.detailSolcitudJson.descuentoPaciente })}
                                idFormElement="descuento"
                                typeElement="input"
                                maxLength="100"
                                labelName="Descuento informado en solicitud de alta:"
                                placeholder="Descuento informado en solicitud de alta"
                                value={props.detailSolcitudJson.descuentoPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                    </div>

                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Domicillio en donde reside el paciente:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, calleNDptoPatient: props.detailSolcitudJson?.direccionPaciente })}
                                idFormElement="calleNDptoPatient"
                                typeElement="input"
                                labelName="Calle, N°, Dpto:"
                                placeholder="Calle, N°, Dpto"
                                hasError={inputValidate?.empty?.calleNDptoPatient}
                                msgError={inputValidate?.msg?.calleNDptoPatient}
                                value={props.detailSolcitudJson?.direccionPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, regionPatient: props.detailSolcitudJson?.regionPaciente })}
                                idFormElement="regionPatient"
                                labelName="Región:"
                                typeElement="input"
                                hasError={inputValidate?.empty?.regionPatient}
                                msgError={inputValidate?.msg?.regionPatient}
                                value={props.detailSolcitudJson?.regionPaciente || ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, comunaPatient: props.detailSolcitudJson?.comunaPaciente })}
                                idFormElement="comunaPatient"
                                labelName="Comuna:"
                                typeElement="input"
                                value={props.detailSolcitudJson?.comunaPaciente || ""}
                                readOnly={true}
                                hasError={inputValidate?.empty?.comunaPatient}
                                msgError={inputValidate?.msg?.comunaPatient}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Datos del representante legal o apoderado del paciente:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setNombreTutor(e.target.value)}
                                idFormElement="nameTutor"
                                typeElement="input"
                                labelName="Nombre:"
                                maxLength="100"
                                placeholder="Nombre Completo"
                                hasError={inputValidate?.empty?.nameTutor}
                                msgError={inputValidate?.msg?.nameTutor}
                                value={nombreTutor}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setRutTutor(e.target.value)}
                                idFormElement="rutTutor"
                                mandatoryElement={true}
                                typeElement="input-mask"
                                labelName="RUT:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutTutor || inputValidate?.validated?.rutTutor}
                                msgError={inputValidate?.msg?.rutTutor}
                                value={ruTutor}
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                maxLength="12"
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setTelefonoTutor(e.target.value)}
                                idFormElement="cellphoneTutor"
                                mandatoryElement={true}
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphoneTutor || inputValidate?.validated?.cellphoneTutor}
                                msgError={inputValidate?.msg?.cellphoneTutor}
                                value={telefonoTutor}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setCorreoTutor(e.target.value)}
                                idFormElement="emailTutor"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailTutor || inputValidate?.validated?.emailTutor}
                                msgError={inputValidate?.msg?.emailTutor}
                                value={correoTutor}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Medio seleccionado para informar la ocurrencia de interrupciones programadas:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, emailInterrupcion: props.detailSolcitudJson?.emailInterrupcion })}
                                idFormElement="emailInterrupcion"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailInterrupcion || inputValidate?.validated?.emailInterrupcion}
                                msgError={inputValidate?.msg?.emailInterrupcion}
                                value={props.detailSolcitudJson?.emailInterrupcion || ""}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Fechas informadas por Electrodependencia:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, fechaDesde: props.detailSolcitudJson?.fechaDesde })}
                                idFormElement="fechaDesde"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Fecha Desde:"
                                placeholder="Fecha Desde"
                                hasError={inputValidate?.empty?.fechaDesde || inputValidate?.validated?.fechaDesde}
                                msgError={inputValidate?.msg?.fechaDesde}
                                value={props.detailSolcitudJson?.fechaDesde? props.detailSolcitudJson.fechaDesde.split("T")[0] : ""}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, fechaHora: props.detailSolcitudJson?.fechaHasta })}
                                idFormElement="fechaHora"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Fecha Hasta:"
                                placeholder="Fecha Hasta"
                                hasError={inputValidate?.empty?.fechaHora || inputValidate?.validated?.fechaHora}
                                msgError={inputValidate?.msg?.fechaHora}
                                value={props.detailSolcitudJson?.fechaHasta? props.detailSolcitudJson.fechaHasta.split("T")[0] : ""}
                                readOnly={true}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Motivo baja:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, motivo: e.target.value })}
                                idFormElement="motivo"
                                mandatoryElement={true}
                                labelName="Descripción motivo:"
                                listOptions={motivoOptions}
                                typeElement="select"
                                value={values.motivo}
                                hasError={inputValidate?.empty?.motivo}
                                msgError={inputValidate?.msg?.motivo}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection>
                    <div className="row">
                        <div className="col-md-12">
                            <CGE.Heading
                                className="color-blue font-weight-bold mb-2"
                                size="4"
                                text={decode_utf8(props.description_forms_tipos_documentacion)}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileCertificate"
                                labelInput="Certificado médico que acredita el alta del paciente:"
                                deleteFile={() => setValues({ ...values, 'fileCertificate': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileCertificate': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileCertificate || inputValidate?.validated?.fileCertificate}
                                msgError={inputValidate?.msg?.fileCertificate}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="declaracionSimple"
                                labelInput="Declaración simple:"
                                deleteFile={() => setValues({ ...values, 'declaracionSimple': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'declaracionSimple': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.declaracionSimple || inputValidate?.validated?.declaracionSimple}
                                msgError={inputValidate?.msg?.declaracionSimple}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.Text
                                className="color-blue font-weight-bold mb-2"
                                size="2"
                                text="(*): En caso de contar con descuento a potencia nomial, es necesario incorporar los respaldos de las placas de los aparatos en la misma
                                sección de documento cargado."
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title="9. Términos y condiciones">
                    <div className="row">
                        <div className="col-md-12">
                            <WebContentTermsElectrod
                                props={props}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxTerms}
                                labelName="Acepto los términos y condiciones"
                                handleChange={() => setValueCheckBoxTerms((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={true}
                                typeElement="input"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FieldRecaptcha
                                onChange={onChangeReCaptcha}
                                sitekey={props.api_key_recaptcha}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <CGE.Button
                            label="Enviar"
                            onClick={() => handleSubmit()}
                        />
                    </div>
                </CGE.PanelSection>
            </CGE.Panel>
        </div>
    )
}

export default BajaSolicitud